export default __webpack_public_path__ + "8c699f4d0352e1148874fec013a0f460.png";